// extracted by css-extract-rspack-plugin
export default {"tooltipTrigger":"_20cf4b61","wrapper":"_bf5c1abf"};